import React from "react";
import { FormattedMessage, FormattedDate } from "react-intl";

import { DataRowNumber, DataRowDateTime } from "@ui/DataRow";
import { messages } from "../../messages";
import { PlaylistSnapshot as Model } from "../../models";

interface Props {
    snapshot: Model;
}

export const PlaylistSnapshot = ({ snapshot }: Props) => (
    <div className="playlist-snapshot">
        {snapshot != null &&
            <div>
                {snapshot.createdAt != null &&
                    <h3>
                        <FormattedMessage {...messages.snapshotTaken}
                            values={{date: <FormattedDate
                                value={snapshot.createdAt}
                                year="numeric"
                                month="long"
                                day="numeric"
                                timeZone="UTC"
                            />}}
                        />
                    </h3>
                }
                {snapshot.numOwnedTracks != null &&
                    <div className="playlist-snapshot__owned-tracks">
                        <DataRowNumber
                            value={snapshot.numOwnedTracks}
                            message={messages.playlistSnapshotColumnNumOwnedTracks} />
                    </div>
                }
                {snapshot.numFollowers != null &&
                    <DataRowNumber
                        value={snapshot.numFollowers}
                        message={messages.playlistSnapshotColumnNumFollowers} />
                }
                {snapshot.meta != null && snapshot.meta.updatedAt != null &&
                    <DataRowDateTime
                        value={snapshot.meta.updatedAt}
                        message={messages.playlistSnapshotColumnMetaUpdatedAt} />
                }
            </div>
        }
    </div>
);
